<template>
  <div class="index">
    <!-- 中间图片部分 -->
    <div class="center">
      <div class="center_BG"></div>
      <img src="https://fview.5kjs.com/activity/21sign/image/pc/indexImage/leftOne.png" alt="" class="leftOne_bg" />
      <img src="https://fview.5kjs.com/activity/21sign/image/pc/indexImage/rightOne.png" alt="" class="rightOne_bg" />
      <div class="table" id="share">
        <CenterTable>
          <!-- 表格标题 -->
          <template v-slot:title>
            <div id="sharhead">学员打卡日记</div></template
          >
          <!-- 表格内容部分 -->
          <template v-slot:content>
            <div class="share_box" v-if="empty">
              <div class="share_box_left" v-loading="loding">
                <shareCard
                  v-for="item in list.list"
                  :key="item.share_id"
                  :myitem="item"
                ></shareCard>
                <MyPaginnation
                  @one="onePage()"
                  @next="nextPage()"
                  :maxPage="MaxPage"
                  @Mychange="changepage($event)"
                ></MyPaginnation>
              </div>
              <div class="share_box_right">
                <topSearch></topSearch>
              </div>
            </div>
            <!-- 空状态 -->
            <div v-else style="width: 100%; padding-bottom: 1.25rem;height:25rem">
              <div
                style="
                  margin: auto;
                  width: 18rem;
                  height: 18rem;
                  text-align: center;
                "
              >
                <img
                  style="width: 90%; height: 90%"
                  src="https://fview.5kjs.com/activity/21sign/image/pc/kong.png"
                  alt=""
                />
                <div style="color: #333333">暂时没有数据</div>
              </div>
            </div>
          </template>
        </CenterTable>
      </div>
    </div>
    <!-- 底部图片部分 -->
    <div class="footer">
      <!-- 第二个表格 -->
    </div>
  </div>
</template>

<script>
// import { mapState } from "vuex";
import CenterTable from "@/components/CenterTable.vue";
import shareCard from "@/components/shareCard.vue";
import topSearch from "@/components/topSearch.vue";
import MyPaginnation from "@/components/MyPaginnation.vue";
export default {
  name: "index",
  components: {
    CenterTable,
    shareCard,
    topSearch,
    MyPaginnation,
  },
  data() {
    return {
      list: [],
      loding: true,
      // 当前页码
      nowPage: 1,
      // 每一页显示多少条数据
      limit: 7,
      // 当前最大页数
      MaxPage: 1,
      // 空状态
      empty: true,
    };
  },
  methods: {
    // 滚动函数
    scrollTo() {
      setTimeout(() => {
        // event为需要跳转的锚点元素ID，如果event为0则返回顶部
        let y = 1080;
        let duration = 500;
        /*y:目标纵坐标,duration:时间(毫秒)*/
        var scrollTop = document.documentElement.scrollTop;

        /*页面当前滚动距离*/
        var distance =
          y - scrollTop; /*结果大于0,说明目标在下方,小于0,说明目标在上方*/
        var scrollCount = duration / 10; /*10毫秒滚动一次,计算滚动次数*/
        var everyDistance =
          distance / scrollCount; /*滚动距离除以滚动次数计算每次滚动距离*/
        for (
          var index = 1;
          index <= scrollCount;
          index++ /*循环设置scrollBy事件,在duration之内,完成滚动效果*/
        )
          setTimeout(function () {
            window.scrollBy(0, everyDistance);
          }, 10 * index);
      }, 0);
    },
    // 请求分享列表
    getShareList(mypage) {
      this.scrollTo();
      let page = this.nowPage;
      if (mypage) {
        page = mypage;
      }
      this.$axios
        .get("/getShareList", {
          params: {
            // token: this.token,
            agency_id: this.agency_id,
            camp_id: 0,
            sort: 2,
            page: page,
            limit: this.limit,
          },
        })
        .then((doc) => {
          if (doc.list == null) {
            // 空状态判定
            this.empty = false;
          } else {
            this.list = doc;
            this.loding = false;
            // 判定当前最大页数
            this.MaxPage = Math.ceil(doc.count / this.limit);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 返回第一页请求
    onePage() {
      if (this.nowPage == 1) {
        this.$message("已经是第一页了噢");
        return;
      }
      this.nowPage = 1;
      this.getShareList(this.nowPage);
    },
    // 下一页
    nextPage() {
      console.log("下一页");
      if (this.nowPage == this.MaxPage) {
        this.$message("已经是最后一页了噢");
        return;
      }
      this.nowPage++;
      this.getShareList(this.nowPage);
    },
    // 选择页码跳转
    changepage(page) {
      this.nowPage = page;
      this.getShareList();
    },
  },
  computed: {
    // ...mapState(["token", "agency_id"]),
     agency_id(){
      if(localStorage.getItem("agency_id")){
        return localStorage.getItem("agency_id")
      }else{
        return 281
      }
    },
     token(){
      if(localStorage.getItem("token")){
        return localStorage.getItem("token")
      }else{
        return null
      }
    },
  },
  created() {
    // 获取路由哈希值用来判断是评论展示页还是评论详情页
    // var id = this.$route.query.id;
    // if (id != null) {
    //   console.log("这个是评论子页面评论编号为" + id);
    //   this.list = 1;
    //   return;
    // }
    // console.log("这个是评论父页面");
    // 请求评论列表
  },
  mounted() {
    this.getShareList();
  },
};
</script>

<style lang="less" scoped>
//   内容中间部分
.center {
  position: relative;
  width: 100%;
  height: auto;
  // background: url(../../assets/indexImage/center.png) no-repeat;
  // background-size: 100% 100%;
  // overflow-y:hidden;
  // 中间表格部分
  .center_BG {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    width: 100%;
    height: 45.4375rem;
    background: url("https://fview.5kjs.com/activity/21sign/image/pc/indexImage/center.png") no-repeat;
    background-size: 100% 100%;
  }
  .table {
    z-index: 9;
    position: relative;
    top: 0;
    left: 0;
  }
  .leftOne_bg {
    position: absolute;
    left: 0;
    top: 15%;
    z-index: 0;
    width: 15rem;
    height: 49.5rem;
  }
  .rightOne_bg {
    position: absolute;
    right: 6.1875rem;
    top: 40%;
    z-index: 0;
    width: 10.5625rem;
    height: 23.4375rem;
  }
  //   打卡分享盒子
  .share_box {
    box-sizing: border-box;
    padding: 0 7.0625rem 6.9375rem;
    display: flex;
    flex-direction: row;
    .share_box_left {
      width: 43.125rem;
      background: #ffffff;
      /deep/ .sharCard:first-child {
        margin-top: 0;
      }
      // // 上下页部分
      // .pagination {
      //   display: flex;
      //   flex-direction: row;
      //   justify-content: center;
      //   align-items: center;
      //   margin-top: 0.75rem;
      //   height: 2.1875rem;
      //   width: 100%;
      //   background: #ffffff;
      //   border: 1px solid #eeeeee;
      //   cursor: pointer;
      // }
      // .previ,
      // .next {
      //   font-size: 12px;
      //   font-family: "Microsoft YaHei";
      //   font-weight: 400;
      //   color: #555555;
      // }
      // .pagination_heng {
      //   margin: 0 2.4375rem;
      //   width: 0.0625rem;
      //   height: 1.125rem;
      //   background: #d9d9d9;
      // }
    }
    .share_box_right {
      margin-left: 0.6875rem;
      width: 18.75rem;
    }
  }
  /deep/ .heng_table {
    background-color: #f7f7f7;
  }
}
// 内容最下部分
.footer {
  padding-bottom: 6.25rem;
  width: 100%;
}
</style>